// Global store for managing the currently selected application
// This ensures only one app is active at a time across the entire platform
import { create } from "zustand";

const LS_KEY = "klmn_selected_app_v1";

// Load from localStorage on initialization
const loadFromStorage = () => {
  try {
    const stored = localStorage.getItem(LS_KEY);
    return stored ? JSON.parse(stored) : null;
  } catch {
    return null;
  }
};

// Save to localStorage
const saveToStorage = (app) => {
  try {
    if (app) {
      localStorage.setItem(LS_KEY, JSON.stringify(app));
    } else {
      localStorage.removeItem(LS_KEY);
    }
  } catch (error) {
    console.error('Failed to save selected app to storage:', error);
  }
};

export const useSelectedAppStore = create((set, get) => {
  // Initialize from localStorage
  const initialApp = loadFromStorage();

  return {
    // Currently selected application
    selectedApp: initialApp,

    // Set the selected application
    setSelectedApp: (app) => {
      set({ selectedApp: app });
      saveToStorage(app);
    },

    // Clear the selected application
    clearSelectedApp: () => {
      set({ selectedApp: null });
      saveToStorage(null);
    },

    // Get the selected app name
    getSelectedAppName: () => {
      const app = get().selectedApp;
      return app?.appName || app?.name || null;
    },

    // Get the selected app prefix (for collection names)
    getSelectedAppPrefix: () => {
      const app = get().selectedApp;
      return app?.appPrefix || app?.appName || null;
    },

    // Check if an app is currently selected
    hasSelectedApp: () => {
      return !!get().selectedApp;
    },
  };
});

